<template>
  <div class="min-h-[900px]">
    <main class="pb-24">
      <SellingTradelinesIntroSection />

      <SellingTradelinesWhatIs class="mt-0 md:mt-20" />

      <SellingTradelinesHowItWorks class="mt-0 md:mt-20" />

      <SellingTradelinesEarningsPotential class="mt-0 md:mt-20" />

      <SellingTradelinesMoreInfo class="mt-0 md:mt-20" />

      <SellingTradelinesSafeAndLegal class="mt-0 md:mt-20" />

      <SellingTradelinesLegalitySeller class="mt-0 md:mt-20" />

      <section id="sellers-feedback" class="mt-0 md:mt-20">
        <LazyLandingPageTestimonials
          :testimonials-data="testimonialsData"
          :user-type="2"
        />
      </section>

      <FaqSection
        id="faq"
        :faq-type="FAQ_TYPE_CARDHOLDER"
        :title="t('selling_tradelines_page.faq')"
        title-class="landing_h2"
        class="mt-20 py-12"
      />
    </main>
  </div>
</template>
<script setup lang="ts">
import SellingTradelinesIntroSection from "~/features/landing-page/components/SellingTradelinesIntroSection.vue";
import SellingTradelinesWhatIs from "~/features/landing-page/components/selling-tradelines/SellingTradelinesWhatIs.vue";
import SellingTradelinesHowItWorks from "~/features/landing-page/components/selling-tradelines/SellingTradelinesHowItWorks.vue";
import SellingTradelinesEarningsPotential from "~/features/landing-page/components/selling-tradelines/SellingTradelinesEarningsPotential.vue";
import SellingTradelinesMoreInfo from "~/features/landing-page/components/selling-tradelines/SellingTradelinesMoreInfo.vue";
import SellingTradelinesSafeAndLegal from "~/features/landing-page/components/selling-tradelines/SellingTradelinesSafeAndLegal.vue";
import SellingTradelinesLegalitySeller from "~/features/landing-page/components/selling-tradelines/SellingTradelinesLegalitySeller.vue";
import FaqSection from "~/features/faq/components/FaqSection.vue";
import { FAQ_TYPE_CARDHOLDER } from "~/features/faq/constants";
import type { TestimonialItem } from "~/features/landing-page/composables/useLandingTestimonials";
import { useI18n } from "vue-i18n";
import { useAuthFetch } from "~/shared/composables/useAuthFetch";
import { useCurrentUserStore } from "~/stores/userStore";

definePageMeta({ layout: "public" });

const { t } = useI18n();
const config = useRuntimeConfig();
const { authFetch } = useAuthFetch();
const currentUserStore = useCurrentUserStore();

const { data: testimonialsRaw } = await useAsyncData(
  "selling-tradelines-testimonials",
  () =>
    authFetch<TestimonialItem[] | { results: TestimonialItem[] }>(
      `${config.public.baseURL}v1/testimonials/`,
      { params: { type: 2, limit: 6, offset: 0 } },
    ).catch(() => []),
);
const testimonialsData = computed(() => {
  const d = testimonialsRaw.value;
  return (Array.isArray(d) ? d : d?.results) ?? [];
});

const siteUrl = (config.public.siteUrl as string) || "";
const route = useRoute();

// Match Nuxt2 prod: full SEO title (no suffix)
const pageTitle = computed(
  () =>
    t("page_data.selling-tradelines.seo_title") ||
    "Selling Tradelines | Sell Your Credit Card Tradelines Now",
);

useSeoMeta({
  title: pageTitle,
  description: () => t("page_data.selling-tradelines.seo_description"),
  ogTitle: pageTitle,
  ogDescription: () => t("page_data.selling-tradelines.seo_description"),
  ogUrl: () => (siteUrl ? `${siteUrl}${route.path}` : undefined),
  ogImage: () => (siteUrl ? `${siteUrl}/boost/4-fb.jpeg` : undefined),
  ogImageAlt: () => t("selling_tradelines_page.og_image_alt"),
  titleTemplate: () => "%s | Sell Your Credit Card Tradelines Now",
});
useHead(() => ({
  meta: [{ name: "keywords", content: t("page_data.selling-tradelines.seo_keywords") }],
}));
</script>
